module.exports = __webpack_public_path__ + "static/PRO004_SystemDiagramBattery-ce0bdd10d916d297c65c0ab69cfef897.jpg";